var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.active)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-icon"},[_c('i',{staticClass:"fas fa-spinner"})])
}]

export { render, staticRenderFns }